<template>
  <div>
    <sidebar3Dian7
      v-if="config.ui_version == 3.7"
      :showPopup="showPopup"
    ></sidebar3Dian7>
    <sidebar v-else :showPopup="showPopup"></sidebar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sidebar from './sidebar.vue';
import sidebar3Dian7 from './sidebar3.7.vue';
export default {
  name: 'Icon',
  computed: {
    ...mapState(['popList', 'userInfo', 'moneyInfo', 'config'])
  },
  components: {
    sidebar,
    sidebar3Dian7
  },
  props: {
    showPopup: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
